function truncate(text, length, suffix) {
    let result = text;
    if (text.length >= length) {
        result = text.substring(0, length) + suffix;
    }
    return result;
}
function insertIf(condition, ...elements) {
    return condition ? elements : [];
}
export { insertIf, truncate, };
